var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.71433V8.28571C16 8.60131 15.7442 8.85717 15.4286 8.85717H8.85716V15.4286C8.85716 15.7442 8.6013 16 8.2857 16H7.71433C7.39873 16 7.14287 15.7442 7.14287 15.4286V8.85717H0.571433C0.255841 8.85717 0 8.60131 0 8.28571V7.71433C0 7.39873 0.255841 7.14288 0.571433 7.14288H7.14287V0.571424C7.14287 0.255832 7.39873 0 7.71433 0H8.2857C8.6013 0 8.85716 0.255832 8.85716 0.571424V7.14288H15.4286C15.7442 7.14288 16 7.39873 16 7.71433Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/ExpandIcon.dfaac59f533e517b4d552a1e3441b10f.svg";
export { ForwardRef as ReactComponent };